/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/segments_config/:segments_config_id/test" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiSegmentsConfigTestCacheKeys } from "./constants";
import type { PostIntegrationsDirectCdiSegmentsConfigTestProps, CdiSegmentsConfigTestResult } from "./types";

export const postCdiSegmentsConfigTest = reactQueryMutationAdapter(
  integrationsDirectCdiSegmentsConfigTestCacheKeys,
  (props: PostIntegrationsDirectCdiSegmentsConfigTestProps): Promise<CdiSegmentsConfigTestResult> => {
    return fetch(
      `/integrations/direct/cdi/segments_config/${props.segmentsConfigId}/test`,
      "POST",
      { partner_name: props.partnerName },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
